<nb-card>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="avatar">
          <ngx-view-user-display
            [user]="lecture.author"
            [mode]="'avatar'"
          ></ngx-view-user-display>
        </div>

        <div>
          <ngx-view-user-display
            [user]="lecture.author"
            [mode]="'name'"
          ></ngx-view-user-display>
          <ngx-view-time-ago
            [currentDate]="lecture.createdOn"
          ></ngx-view-time-ago>

          <div *ngIf="lecture.refTitle" class="text-link">
            <nb-icon icon="globe-outline"></nb-icon>
            <a class="link" (click)="navigateRef(lecture)">
              {{
                lecture.refTitle.length < 60
                  ? lecture.refTitle
                  : lecture.refTitle.substring(0, 60) + "..."
              }}
            </a>
          </div>

          <div *ngIf="!lecture.refTitle || mode == 'detail'" class="text-link">
            <nb-icon icon="hash-outline"></nb-icon>
            <ngx-view-tags
              [tags]="lecture.tags"
              (onTagSelected)="tagSelected($event)"
            ></ngx-view-tags>
          </div>

          <div *ngIf="lecture.createdBy == uid">
            <button
              nbButton
              ghost
              size="tiny"
              [status]="
                lecture.status == 1
                  ? 'success'
                  : lecture.status == -1
                  ? 'warning'
                  : 'info'
              "
              (click)="edit(lecture)"
            >
              <nb-icon
                [icon]="lecture.status == 1 ? 'eye-outline' : 'eye-off-outline'"
              ></nb-icon>
              <span>{{
                lecture.status == 1
                  ? "Xuất bản"
                  : lecture.status == -1
                  ? "Ẩn nội dung"
                  : "Đang thực hiện"
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="button-action">
      <ngx-button-approve
        *ngIf="mode == 'review' && !lecture.isReviewed"
        [lecture]="lecture"
        (onApprove)="approve($event)"
      >
      </ngx-button-approve>

      <ngx-button-bookmark *ngIf="mode == 'detail'" [lecture]="lecture">
      </ngx-button-bookmark>

      <button
        nbButton
        ghost
        shape="round"
        status="primary"
        size="small"
        class="action-button"
        [disabled]="loading"
        [class.btn-pulse]="loading"
        [nbContextMenu]="menuItems"
        [nbContextMenuTag]="'action-buttons-' + lecture.id"
        (click)="loadButtonAction(lecture)"
      >
        <nb-icon icon="more-horizontal-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body *ngIf="mode != 'detail'">
    <h6 class="link text-heading" (click)="loadContent(true)">
      {{ lecture.title }}
    </h6>
    <div class="content">
      <ngx-view-image
        *ngIf="lecture.coverUrl"
        [imageURL]="lecture.coverUrl"
        (click)="loadContent(true)"
      ></ngx-view-image>

      <div *ngIf="lecture.description" class="text-hint description">
        {{ lecture.description }}
      </div>
    </div>

    <a
      *ngIf="lecture.sourceType && !isMore"
      (click)="loadContent(true)"
      class="link text-link"
    >
      <nb-icon icon="chevron-down-outline"></nb-icon>
      Xem thêm
    </a>

    <nb-card *ngIf="lecture.sourceType && isMore">
      <nb-card-body
        *ngIf="lecture.sourceType == 'images' && lecture.imagesUrl.length > 0"
      >
        <ngx-view-gallery [imagesUrl]="lecture.imagesUrl"> </ngx-view-gallery>
      </nb-card-body>

      <nb-card-body
        *ngIf="lecture.sourceType == 'video' && lecture.videoUrl != ''"
      >
        <ngx-view-video [url]="lecture.videoUrl"></ngx-view-video>
      </nb-card-body>

      <nb-card-body
        *ngIf="lecture.sourceType == 'document' && lecture.content != ''"
      >
        <ngx-view-document [content]="lecture.content"> </ngx-view-document>
      </nb-card-body>
    </nb-card>

    <a
      *ngIf="lecture.sourceType && isMore"
      (click)="loadContent(false)"
      class="link text-link"
    >
      <nb-icon icon="chevron-up-outline"></nb-icon>
      Thu gọn
    </a>
  </nb-card-body>

  <nb-card-footer>
    <div class="button-actions">
      <ngx-view-like *ngIf="mode == 'detail'" [lecture]="lecture">
      </ngx-view-like>
      <button
        *ngIf="mode != 'detail'"
        nbButton
        ghost
        shape="semi-round"
        size="small"
      >
        <i class="fas fa-thumbs-up"></i>
        <span>{{ lecture.noLiked | number }} </span>
      </button>

      <button
        *ngIf="lecture.showComments"
        nbButton
        ghost
        status="info"
        size="small"
        (click)="reply()"
      >
        <nb-icon icon="message-square-outline"></nb-icon>

        <div *ngIf="!lecture.noComment || lecture.noComment == 0">
          Bình luận
        </div>

        <div *ngIf="lecture.noComment > 0" style="text-transform: lowercase">
          &nbsp;Xem <span>{{ lecture.noComment | number }} </span> bình luận
        </div>
      </button>

      <ngx-button-report-spam
        [lecture]="lecture"
        (onReport)="report($event)"
      ></ngx-button-report-spam>
    </div>

    <nb-card *ngIf="view === 'replies'" class="replies">
      <nb-card-body>
        <ngx-view-comments
          [lecture]="lecture"
          [mode]="mode"
          (onClose)="closeReply()"
        >
        </ngx-view-comments>
      </nb-card-body>
    </nb-card>
  </nb-card-footer>
</nb-card>
